// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".create-columns {\n  box-shadow: 10px 4px 41px -19px rgba(0, 0, 0, 0.82) !important;\n  width: 800px !important;\n}", "",{"version":3,"sources":["webpack://src/components/bin-plus-tables/bin-plus-table.scss"],"names":[],"mappings":"AAAA;EAEE,8DAAA;EACA,uBAAA;AAAF","sourcesContent":[".create-columns\n{\n  box-shadow: 10px 4px 41px -19px rgba(0, 0, 0, 0.82) !important;\n  width: 800px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
